import { createReducer, Action, on } from '@ngrx/store';

import { State, initialState } from './state';
import * as actions from './actions';

import { TradeStatusesEnum } from '@shared/models';

const reducer = createReducer(
  initialState,
  on(actions.load, (state => {
    return {
      ...state,
      loading: true
    };
  })),
  on(actions.loadSuccess, ((state, { trade })  => {
    return {
      ...state,
      loading: false,
      data: trade
    };
  })),
  on(actions.clear, ((state)  => {
    return initialState;
  })),
  on(actions.end, ((state)  => {
    return {
      ...state,
      data: {
        ...state.data,
        status: TradeStatusesEnum.Closed
      }
    };
  })),
  on(actions.approve, ((state)  => {
    return {
      ...state,
      data: {
        ...state.data,
        status: TradeStatusesEnum.Payment
      }
    };
  })),
  on(actions.updateBlockBalance, ((state, { transaction })  => {
    return {
      ...state,
      data: {
        ...state.data,
        userBlocksBalance: transaction.noOfBlocks,
        blocksSold: transaction.blocksSold
      }
    };
  }))
);

export function tradeReducer(state: State, action: Action) {
  return reducer(state, action);
}
